
import Icon from "@/orders/components/Icon/index.vue";
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { ServicePoint } from "@/orders";
import { Getter } from "vuex-class";

@Component({
  components: {
    Icon,
  },
})
export class ServicePoints extends Vue {
  @Getter("getCashTodayServicePointsOrders") getCashTodayServicePoints!: ServicePoint[];
  @Model("value") filteredServicePoints!: ServicePoint[];
  @Prop({ required: true }) items!: ServicePoint[];

  eyes = require("@/orders/assets/icons/icon-eye.svg");
  selectedItems: ServicePoint[] = [];
  filterItems: ServicePoint[] = [];
  searchTerm = "";
  isSelectAll = true;
  isSelectAllCashToday = false;

  created(): void {
    this.filterItems = this.getFilterItems();
    this.selectedItems = [...this.filteredServicePoints];
  }

  selectOrUnselectAll(): void {
    if (this.getCashTodayServicePoints.length === this.filterItems.length) {
      this.isSelectAllCashToday = this.isSelectAll;
      this.selectedItems = this.isSelectAll ? [...this.filterItems] : [];
      return;
    }

    if (this.getCashTodayServicePoints.length > 0) {
      this.isSelectAllCashToday = !this.isSelectAll;
    }

    this.selectedItems = this.isSelectAll ? [...this.filterItems] : [...this.getCashTodayServicePoints];
  }

  selectOrUnselectAllCashToday(): void {
    if (this.getCashTodayServicePoints.length === this.filterItems.length) {
      this.isSelectAll = this.isSelectAllCashToday;
      this.selectedItems = this.isSelectAll ? [...this.filterItems] : [];
      return;
    }

    this.isSelectAll = !this.isSelectAllCashToday;

    this.selectedItems = this.isSelectAllCashToday ? [...this.getCashTodayServicePoints] : [...this.filterItems];
  }

  @Watch("selectedItems")
  onChangeItemsSelected(): void {
    this.isSelectAll = this.selectedItems.length === this.filterItems.length;
    if (this.getCashTodayServicePoints.length > 0) {
      this.isSelectAllCashToday = this.areServicePointsEqual(this.selectedItems, this.getCashTodayServicePoints, "id");
    }
    this.$emit("value", this.selectedItems);
  }

  areServicePointsEqual<K extends keyof ServicePoint>(
    firstArray: ServicePoint[],
    secondArray: ServicePoint[],
    attribute: K
  ): boolean {
    if (firstArray.length !== secondArray.length) {
      return false;
    }

    const firstArrayAttributes = firstArray.map((item) => item[attribute]);
    const secondArrayAttributes = secondArray.map((item) => item[attribute]);

    const firstSortedArray = [...firstArrayAttributes].sort();
    const secondSortedArray = [...secondArrayAttributes].sort();

    return firstSortedArray.every((element, index) => element === secondSortedArray[index]);
  }

  getFilterItems(): ServicePoint[] {
    return this.items.filter((item: ServicePoint) => {
      const searchTermLowerCase = this.searchTerm.toLowerCase();
      return (
        item.name.toLowerCase().includes(searchTermLowerCase) ||
        item.code.toLowerCase().includes(searchTermLowerCase) ||
        item.name
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .indexOf(this.searchTerm.toLowerCase()) >= 0 ||
        item.code
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .indexOf(this.searchTerm.toLowerCase()) >= 0
      );
    });
  }
}

export default ServicePoints;
